import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import SubActivityForm from "../SubActivityFormsModal/SubActivityForms.vue";
import StudyActivityForms from "../StudyActivityForms/StudyActivityForms.vue";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  name: 'visitActivityOrder',
  components: {
    Multiselect,
    customModal,
    VPagination,
    SubActivityForm,
    StudyActivityForms,
  },
  props: {
    fromPage: {
      type: String,
      default: "studyProfile"
    },
    visitId: {
      type: String,
      required: true
    },
    version: {
      type: String,
      default: ""
    },
    subjectId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      studyId: '',
      activityForm: {
        selectedActivityId: "",
        activityName: "",
        order: ""
      },
      head: "",
            isSaving: false,
      activityOptions: [],
      activityList: [],
      editingIndex: null,
      editedActivity: {},
      noActivitiesFound: false,
      activityCount: 0,
      validations: [false, false],
      currentPage: 1,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      SortProperty: "CreatedAt",
      SortOrder: false,
      subActivitys: [],
      showSubFormModal: false,
      showStudyFormModal: false,
      formlist: [],
      formPatientId: "",
      formVisitNo: "",
      formActivityId: "",
      formActivityOrder: "",
      // NEW: isRequired for add form
      isRequired: true,
    };
  },
  mounted() {
    window.addEventListener("studyIdChanged", async (event) => {
      this.studyId = store.getters.getStudyIs;
      await this.getStudyDetails();
    });

    this.studyId = store.getters.getStudyIs;
    this.token = store.getters.getIdToken;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    };
    if (this.fromPage === "studyProfile") {
      this.getVisitInfo();
      this.fetchActivityOptions();
    } else if (this.fromPage === "visitSchedule") {
      this.getSubActivitys();
    }
  },
  methods: {
    async getVisitInfo() {
      await axios
        .get(
          `${this.baseurl}/management/visit/listvisitactivity?visitId=${this.visitId}&pageindex=${this.pageindex}&pagesize=${this.pagesize}`,
          this.head
        )
        .then((res) => {
          this.activityList = res.data.entities || [];
          this.totalPage = Math.ceil(res.data.totalCount / this.pagesize);
          this.activityCount = res.data.totalCount;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async fetchActivityOptions() {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/study/listsoa?studyId=${this.studyId}&studyVersion=${this.version}&activityType=&pageindex=1&pagesize=100`,
          this.head
        );
        this.activityOptions = response.data.entities;
      } catch (error) {
        console.error("Error loading activity options", error);
      }
    },
    async getSubActivitys() {
  try {
    const response = await axios.get(
      `${this.baseurl}/management/patientschedule/getactivitynames?subjectId=${this.subjectId}&visitNo=${this.visitId}&studyId=${this.studyId}`,
      this.head
    );
    console.log("Sub Activity Response:", response.data.data);
    
    const allActivities = response.data.data || [];
    const requiredActivities = allActivities.filter(item => item.isRequired === true);
    this.activityList = requiredActivities;
    this.activityCount = requiredActivities.length;
    
    this.totalPage = Math.ceil(this.activityCount / this.pagesize);
  
    if (this.currentPage > this.totalPage && this.totalPage > 0) {
      this.currentPage = this.totalPage;
      this.pageindex = this.currentPage;
    }
  } catch (error) {
    console.error("Error loading sub activity options", error);
  }
},
    // async getSubActivitys() {
    //   try {
    //     const response = await axios.get(
    //       `${this.baseurl}/management/patientschedule/getactivitynames?subjectId=${this.subjectId}&visitNo=${this.visitId}&studyId=${this.studyId}`,
    //       this.head
    //     );
    //     console.log("Sub Activity Response:", response.data.data);
    //     this.activityList = response.data.data || [];
    //     this.totalPage = Math.ceil(response.data.totalCount / this.pagesize);
    //     this.activityCount = response.data.totalCount;
    //   } catch (error) {
    //     console.error("Error loading sub activity options", error);
    //   }
    // },
    async addActivity() {
      await this.nullValidation();
      if (this.validations.includes(true)) {
        return;
      }
      if (this.activityForm.order <= this.activityCount) {
        if (!confirm(`Activity order ${this.activityForm.order} already exists. Do you want to insert and automatically reorder others?`)) return;
      }

      const selectedActivity = this.activityOptions.find(
        (a) => a.id === this.activityForm.selectedActivityId
      );

      this.activityForm.activityName = selectedActivity ? selectedActivity.activityName : "";
            this.isSaving = true;
      try {

        const payload = {
          visitId: this.visitId,
          activityId: this.activityForm.selectedActivityId,
          activityName: this.activityForm.activityName,
          activityOrder: this.activityForm.order,
          isRequired: this.isRequired   // <-- ADDED
        };

        const response = await axios.put(
          `${this.baseurl}/management/visit/addvisitactivity`,
          payload,
          this.head
        );

        console.log("Activity added successfully", response.data);
        alert("Activity added successfully");
        // Reset form
                this.isSaving = false;
        this.activityForm = {
          selectedActivityId: "",
          activityName: "",
          order: ""
        };
        this.isRequired = false; // reset checkbox
        this.getVisitInfo();
      } catch (error) {
        let errorMessage = "Failed to add activity";
        if (error.response?.data?.messages?.length > 0) {
          const activityMessage = error.response.data.messages.find(m =>
            m.includes("An activity with name")
          );
          errorMessage = activityMessage || error.response.data.messages.join("\n");
          alert("Activity name already exists");
                    this.isSaving = false;
        } else if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
                    this.isSaving = false;
        }
        console.error("Error adding activity:", errorMessage);
      }
    },
    activityOrderOptions(isEdit = false) {
      if (!this.activityList.length) return [];
      const orders = this.activityList.map(item => item.activityOrder);
      const maxOrder = Math.max(...orders);
      const length = isEdit ? maxOrder : maxOrder + 1;
      return Array.from({ length }, (_, i) => i + 1).reverse();
    },
    editActivity(index) {
      this.editingIndex = index;
      // Copy the entire item, including isRequired
      this.editedActivity = {
        ...this.activityList[index],
        isRequired: this.activityList[index].isRequired || false // default if missing
      };
    },
    async saveEditedActivity(index) {
      console.log("Saving edited activity:", index);
      if (!confirm(this.$t(`navigations.do you want to edit this activity with the existing order number and automatically reorder the others?`))) return;
      try {
               // this.isSaving = true;
        const selectedActivity = this.activityOptions.find(
          (a) => a.id === this.editedActivity.activityId
        );

        const payload = {
          visitId: this.visitId,
          activityId: this.editedActivity.activityId,
          activityName: selectedActivity ? selectedActivity.activityName : "",
          activityOrder: this.editedActivity.activityOrder,
          oldOrder: this.activityList[index].activityOrder,
          isRequired: this.editedActivity.isRequired   // <-- ADDED
        };

        const response = await axios.put(
          `${this.baseurl}/management/visit/editvisitactivity`,
          payload,
          this.head
        );

        console.log("Activity updated successfully", response.data);
        alert("Activity updated successfully");
               //this.isSaving = false;
        this.getVisitInfo();
        this.cancelEdit();
      } catch (error) {
        let errorMessage = "Failed to update activity";
                this.isSaving = false;
        if (error.response?.data?.messages?.length > 0) {
          const activityMessage = error.response.data.messages.find(m =>
            m.includes("An activity with name")
          );
          errorMessage = activityMessage || error.response.data.messages.join("\n");
          alert("Activity name already exists");
                    this.isSaving = false;
        } else if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        }
        console.error("Error updating activity:", errorMessage);
               // this.isSaving = false;
      }
    },
    cancelEdit() {
      this.editingIndex = null;
      this.editedActivity = {};
    },
    closeActivityModal() {
      this.validations = [false, false];
      this.$emit("closeModal");
    },
    async nullValidation() {
      console.log("Validating fields...");
      this.validations = [false, false];
      const fields = [
        { value: this.activityForm.selectedActivityId, index: 0 },
        { value: this.activityForm.order, index: 1 },
      ];
      fields.forEach(({ value, index }) => {
        this.validations[index] = !value;
      });
      console.log("Validating fields...", this.validations);
    },
    async removeActivity(index) {
      const activity = this.activityList[index];
      console.log("Deleting activity:", activity);
      if (!confirm(this.$t(`navigations.do you want to delete this activity and automatically reorder the others?`))) return;

      try {
        const response = await axios.delete(
          `${this.baseurl}/management/visit/removevisitactivity?visitId=${this.visitId}&ActivityOrder=${activity.activityOrder}`,
          this.head
        );
        console.log("Activity deleted successfully", response.data);
        alert(this.$t("navigations.visit activity deleted successfully"));
        await this.getVisitInfo();
        if (this.activityList.length === 0 && this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          this.pageindex = this.currentPage;
          await this.getVisitInfo();
        }
      } catch (error) {
        console.error("Error deleting activity", error);
      }
    },
    loadPage(page) {
  this.currentPage = page;
  this.pageindex = page;
  if (this.fromPage === 'studyProfile') {
    this.getVisitInfo();
  } else if (this.fromPage === 'visitSchedule') {
    this.getSubActivitys();   
  }
},
    // loadPage(page) {
    //   this.currentPage = page;
    //   this.pageindex = page;
    //   this.getVisitInfo();
    // },
    async viewForm(formId, isPatientVisit) {
      this.$router.push(`/showform/forms/${formId}/false`);
    },
    async openFormsModal(visitNo, patientId, activityId, activityOrder) {
      if (this.fromPage == "studyProfile") {
        this.formActivityId = activityId;
        this.showStudyFormModal = true;
      } else if (this.fromPage == "visitSchedule") {
        this.formPatientId = patientId;
        this.formVisitNo = visitNo;
        this.formActivityId = activityId;
        this.formActivityOrder = activityOrder;
        this.showSubFormModal = true;
      }
    },
    async closeFormModal() {
      this.showSubFormModal = false;
      this.showStudyFormModal = false;
    },
    async listvisitForms(visitNo, patientId, studyId, activityId) {
      await axios
        .get(
          `${this.baseurl}/management/patientschedule/getfromsbyvisit?studyId=${this.studyId}&patientID=${patientId}&visitNo=${visitNo}&activityId=${activityId}`,
          this.head
        )
        .then((res) => {
          console.log("Visit form list is...", res);
          this.formlist = res.data.data;
        })
        .catch((err) => console.log(" error in getting visit forms...", err));
    },
  }
}